export default __webpack_public_path__ + "12ef544a4ac91ea5b4be5e774c76f5cf.png";